(() => {
  'use strict';
  const configNode = document.getElementById('posy-planner-review-config');
  if (!configNode || document.getElementById('posy-planner-review')) return;
  const config = JSON.parse(configNode.textContent);
  if (!/planner|journal|recipe book|notebook/i.test(config.title)) return;
  const text = config.labels;
  // Let Selleasy finish its selected extras before UpCart handles the planner.
  // UpCart intercepts the original click above Selleasy's button listener.
  // Use the app's existing API, including its quantities and discount handling.
  // Never construct a second cart request or execute the app's custom-JS field.
  let addingExtras = false;
  window.addEventListener('click', event => {
    if (event.target.closest?.('button#StickyATCButton')) {
      const mainButton = document.querySelector('form#AddToCartForm button#AddToCart');
      if (!mainButton) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      if (!addingExtras) mainButton.click();
      return;
    }
    const button = event.target.closest?.('button#AddToCart');
    if (!button || !button.closest('form#AddToCartForm')) return;
    if (addingExtras && !event.isTrusted) {
      // Selleasy forwards one programmatic click after its add-on request.
      addingExtras = false;
      button.removeAttribute('aria-busy');
      return;
    }
    const selected = button.closest('form').querySelector('.lb-spc-details-checkbox:checked');
    if (!selected && !addingExtras) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    if (addingExtras) return;
    const add = window.lbUpsellComponents?.ppaWidget?.handleAddToCart;
    if (typeof add !== 'function') {
      window.alert('Your selected extras are still loading. Please try again in a moment.');
      return;
    }
    addingExtras = true;
    button.setAttribute('aria-busy', 'true');
    add(button);
  }, true);
  let form, panel, rows, totalNode, lastState = '', scheduled = false;
  let targets = [];
  const clean = value => String(value || '').replace(/\s+/g, ' ').trim();
  const moneyNumber = value => {
    let raw = clean(value).replace(/[^\d.,-]/g, '');
    const decimal = raw.match(/[.,](\d{2})$/);
    if (decimal) raw = raw.slice(0, -3).replace(/[.,]/g, '') + '.' + decimal[1];
    else raw = raw.replace(/[.,]/g, '');
    const number = Number(raw);
    return raw && Number.isFinite(number) ? number : null;
  };
  const money = amount => new Intl.NumberFormat(document.documentElement.lang || 'en', {style:'currency', currency:config.currency, currencyDisplay:'code'}).format(amount);
  const node = (tag, className, value) => {
    const element = document.createElement(tag);
    if (className) element.className = className;
    if (value !== undefined) element.textContent = value;
    return element;
  };
  const addRow = (label, value, target) => ({label:clean(label), value:clean(value), target});
  const collect = () => {
    const data = [addRow(text.design, config.title)];
    const size = config.title.match(/(?:8[.,]5\s*[x×]\s*11|6\s*[x×]\s*9)/i);
    if (size) data.push(addRow(text.size, size[0].replace(/[x×]/i, ' × ')));
    form.querySelectorAll('select[id^="SingleOptionSelector-"]').forEach((select, index) => {
      const wrapper = select.closest('.selector-wrapper');
      const label = clean(wrapper?.querySelector('label')?.textContent || config.options[index] || text.choice).replace(/^\d+\.\s*/, '');
      const displayed = wrapper?.querySelector('button .header--supporting-text')?.textContent;
      data.push(addRow(label, displayed || select.selectedOptions[0]?.textContent || select.value, wrapper?.querySelector('button') || select));
    });
    form.querySelectorAll('input[name^="properties["],textarea[name^="properties["],select[name^="properties["]').forEach(field => {
      if (field.type === 'hidden' || field.type === 'file' || field.disabled || /^properties\[_/.test(field.name)) return;
      if ((field.type === 'checkbox' || field.type === 'radio') && !field.checked) return;
      const name = field.name.slice(11, -1);
      const value = clean(field.tagName === 'SELECT' ? field.selectedOptions[0]?.textContent : field.value);
      const empty = /Personalization for front cover/i.test(name) ? text.cover_empty : text.not_selected;
      data.push(addRow(/Personalization for front cover/i.test(name) ? text.cover_text : name, value || empty, field));
    });
    const extras = [];
    let extrasTotal = 0, reliable = true;
    form.querySelectorAll('.lb-upsell-product-card').forEach(card => {
      const checkbox = card.querySelector('input.lb-spc-details-checkbox');
      if (!checkbox?.checked) return;
      const name = clean(card.querySelector('.lb-spc-details-name')?.textContent);
      const variant = card.querySelector('select.lb-shared-variants-select');
      const detail = clean(variant?.selectedOptions[0]?.textContent);
      const priceText = clean(card.querySelector('.lb-spc-details-price')?.textContent);
      const amount = moneyNumber(priceText);
      const units = Number(clean(card.querySelector('.lb-spc-details-qty-picker-q')?.textContent) || 1);
      if (amount === null || !Number.isInteger(units) || units < 1) reliable = false; else extrasTotal += amount * units;
      const unitLabel = units > 1 ? `${units} × ${priceText}` : priceText;
      extras.push(addRow(name || text.extra, [detail, unitLabel].filter(Boolean).join(' · '), checkbox));
    });
    if (form.querySelector('.lb-upsell-product-card')) {
      data.push(...(extras.length ? extras : [addRow(text.extras, text.none, form.querySelector('.lb-spc-details-checkbox'))]));
    }
    const priceElement = [...form.querySelectorAll('.variant-price,[itemprop="price"]')].find(element => element.tagName !== 'META' && element.getClientRects().length && moneyNumber(element.textContent) !== null);
    const base = moneyNumber(priceElement?.textContent);
    const paidPersonalization = [...form.querySelectorAll('.pplr_option_price_span')].some(element => moneyNumber(element.textContent) > 0);
    if (paidPersonalization) reliable = false;
    const quantity = Number(form.querySelector('[name="quantity"]')?.value || 1);
    const variant = form.querySelector('select[name="id"],input[name="id"]');
    if (quantity !== 1) data.push(addRow(text.quantity, quantity));
    const total = reliable && base !== null && variant?.value && quantity === 1 ? money(base + extrasTotal) : text.check_total;
    return {data, total};
  };
  const refresh = () => {
    scheduled = false;
    if (!form?.isConnected || !panel?.isConnected || form !== document.querySelector('form#AddToCartForm')) { connect(); return; }
    document.querySelectorAll('#posy-planner-review').forEach(element => { if (element !== panel) element.remove(); });
    const state = collect();
    const signature = JSON.stringify({data:state.data.map(({label,value}) => [label,value]),total:state.total});
    targets = state.data.map(row => row.target);
    if (signature === lastState) return;
    lastState = signature;
    const activeIndex = panel.contains(document.activeElement) ? document.activeElement.dataset.reviewEdit : undefined;
    rows.replaceChildren();
    state.data.forEach((row, index) => {
      const wrap = node('div','posy-review__row');
      wrap.append(node('dt','posy-review__label',row.label));
      const value = node('dd','posy-review__value',row.value);
      if (row.target) {
        const edit = node('button','posy-review__edit',text.edit);
        edit.type = 'button'; edit.dataset.reviewEdit = String(index);
        edit.setAttribute('aria-label',`${text.edit} ${row.label}`);
        value.append(edit);
      }
      wrap.append(value); rows.append(wrap);
    });
    totalNode.textContent = state.total;
    if (activeIndex !== undefined) panel.querySelector(`[data-review-edit="${activeIndex}"]`)?.focus({preventScroll:true});
  };
  const schedule = () => { if (!scheduled) { scheduled = true; requestAnimationFrame(refresh); } };
  const connect = () => {
    const found = document.querySelector('form#AddToCartForm');
    const button = found?.querySelector('button#AddToCart');
    if (!found || !button || !found.querySelector('select[id^="SingleOptionSelector-"],input[name^="properties["]')) return;
    document.querySelectorAll('#posy-planner-review').forEach(element => element.remove());
    lastState = '';
    form = found;
    panel = node('section','posy-review'); panel.id = 'posy-planner-review';
    panel.setAttribute('aria-labelledby','posy-planner-review-title');
    const heading = node('h2','posy-review__title',text.heading); heading.id = 'posy-planner-review-title';
    panel.append(heading,node('p','posy-review__intro',text.intro));
    const live = node('div','posy-review__live'); live.setAttribute('aria-live','polite'); live.setAttribute('aria-atomic','true');
    rows = node('dl','posy-review__rows'); live.append(rows);
    const totalWrap = node('div','posy-review__total'); totalWrap.append(node('span','',text.subtotal)); totalNode = node('strong',''); totalWrap.append(totalNode); live.append(totalWrap);
    panel.append(live,node('p','posy-review__note',text.note));
    button.parentElement.insertBefore(panel,button);
    panel.addEventListener('click', event => {
      const control = event.target.closest('[data-review-edit]');
      if (!control) return;
      const target = targets[Number(control.dataset.reviewEdit)];
      if (!target) return;
      const focusTarget = target.getClientRects().length ? target : target.closest('.selector-wrapper')?.querySelector('button');
      focusTarget?.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',block:'center'});
      focusTarget?.focus({preventScroll:true});
    });
    refresh();
  };
  document.addEventListener('input', event => { if (event.target.closest('form#AddToCartForm')) schedule(); }, true);
  document.addEventListener('change', event => { if (event.target.closest('form#AddToCartForm')) schedule(); }, true);
  const observer = new MutationObserver(records => {
    if (records.every(record => panel?.contains(record.target))) return;
    if (!panel || !panel.isConnected) connect();
    else if (records.some(record => form.contains(record.target))) schedule();
  });
  observer.observe(document.body,{childList:true,subtree:true,characterData:true,attributes:true,attributeFilter:['value','checked','disabled']});
  connect();
})();
